import {
  NumberPage,
  PageButton,
  PaginationContainer,
  styledNumber,
  styledPage,
  unstyledPage,
} from 'components/Pagination/styles'
import {
  HiChevronDoubleLeft,
  HiChevronDoubleRight,
  HiChevronLeft,
  HiChevronRight,
} from 'react-icons/hi'
import React, { useState, useEffect } from 'react'
import {
  FooterText,
  FooterContainer
} from 'components/SharedTable/styles'

interface IPaginationProps {
  paginationTotal?: number
  paginationItensByPage?: number
  paginationNumberSelectedPage?: Function
  paginationCurrentPage?: number
  tableSize?: number
}

type PaginationProps = IPaginationProps

const Pagination: React.FC<PaginationProps> = ({ paginationTotal, paginationItensByPage, paginationNumberSelectedPage, paginationCurrentPage, tableSize }) => {
  const [currentPage, setCurrentPage] = useState(0)
  const [numberOfPages, setNumberOfPages] = useState(0)


  const handleClickNexPage = () => {
    paginationNumberSelectedPage(currentPage + 1)
    setCurrentPage(currentPage + 1)
  }

  const handleClickPrevious = () => {
    paginationNumberSelectedPage(currentPage - 1)
    setCurrentPage(currentPage - 1)
  }

  const handleClickFirstPage = () => {
    paginationNumberSelectedPage(1)
    setCurrentPage(0)
  }

  const handleClickFinalPage = () => {
    paginationNumberSelectedPage(numberOfPages - 1)
    setCurrentPage(numberOfPages - 1)
  }

  const getItensPagination = (paginationTotal: number, paginationItensByPage: number) => {
    let content = [];
    let numberPages: number = Math.ceil(paginationTotal / paginationItensByPage)
    numberPages = numberPages < 1 ? 1 : numberPages

    const starteExtra = (currentPage + 1) === numberPages ? 4 : 2
    const startPage = Math.max(currentPage - starteExtra, 0);
    const endExtra = currentPage === 0 ? 5 : 3
    const endPage = Math.min((currentPage + endExtra), numberPages);
    for (let i = startPage; i < endPage; i++) {
      let label = i
      label++
      content.push(
        <NumberPage
          key={i}
          data-testid="pagination-item"
          onClick={() => {
            paginationNumberSelectedPage(i)
            setCurrentPage(i)
          }}
          className={currentPage === i ? styledNumber : ''}
        >
          {label}
        </NumberPage>)
    }
    return content
  }
  /**
   * Inicia o calculo para obter o numero de icones que serão gerados na paginação.
   */
  useEffect(() => {
    setNumberOfPages(Math.ceil(paginationTotal / paginationItensByPage))
  }, [paginationTotal, paginationItensByPage])
  /**
   * Atualiza o numero de pagina conforme a função 
   */
  useEffect(() => {
    setNumberOfPages(Math.ceil(paginationTotal / paginationItensByPage))
  }, [paginationNumberSelectedPage])
  /**
   * Escuta o valor moficado fora do componente e atualiza a pagina corrente do state atual
   */
  useEffect(() => {
    setCurrentPage(paginationCurrentPage || 0)
  }, [paginationCurrentPage])

  /**
   * Ao mudar o total de itens por aba retorna para o primeiro item de paginaçao
   */
  useEffect(() => {
    setCurrentPage(0)
  }, [paginationTotal])

  const getPageRange = () => {
    const rangeStart = (paginationItensByPage * currentPage) + 1
    const rangeEnd = (paginationItensByPage * currentPage) + paginationItensByPage
    const rangeEndTreated = rangeEnd > paginationTotal ? paginationTotal : rangeEnd
    const textPresentationn = tableSize > 0 ? `${rangeStart} de ${rangeEndTreated}` : 0
    return `Mostrando ${textPresentationn} de ${paginationTotal} registros`
  }
  return (
    <FooterContainer>
      <FooterText>
        {getPageRange()}
      </FooterText>
      {
        tableSize > 0 &&
        <PaginationContainer>
          <PageButton data-testid="first-page"
            onClick={handleClickFirstPage}
            disabled={currentPage === 0}
            className={currentPage === 0 ? unstyledPage : styledPage}
          >
            <HiChevronDoubleLeft />
          </PageButton>
          <PageButton data-testid="previous-page"
            disabled={currentPage === 0}
            onClick={handleClickPrevious}
            className={currentPage === 0 ? unstyledPage : styledPage}
          >
            <HiChevronLeft />
          </PageButton>

          <div className='flex'>
            {getItensPagination(paginationTotal, paginationItensByPage)}
          </div>

          <PageButton data-testid="next-page"
            disabled={numberOfPages === (currentPage + 1)}
            onClick={handleClickNexPage}
            className={numberOfPages === (currentPage + 1) ? unstyledPage : styledPage}
          >
            <HiChevronRight />
          </PageButton>

          <PageButton data-testid="final-page"
            disabled={numberOfPages === (currentPage + 1)}
            onClick={handleClickFinalPage}
            className={numberOfPages === (currentPage + 1) ? unstyledPage : styledPage}
          >
            <HiChevronDoubleRight />
          </PageButton>

          <div></div>
        </PaginationContainer>
      }
    </FooterContainer>
  )
}

export { Pagination }